import { render, staticRenderFns } from "./check-photo.vue?vue&type=template&id=a2c318d4&scoped=true"
import script from "./check-photo.vue?vue&type=script&lang=js"
export * from "./check-photo.vue?vue&type=script&lang=js"
import style0 from "./check-photo.vue?vue&type=style&index=0&id=a2c318d4&prod&scoped=true&lang=css"
import style1 from "./check-photo.vue?vue&type=style&index=1&id=a2c318d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c318d4",
  null
  
)

export default component.exports